import type { Environment } from '@change-corgi/config/environments';

import __googleAnalytics from '../config/googleAnalytics.json';

export const googleAnalyticsTrackingIds = __googleAnalytics as Readonly<Record<Environment, string>>;
